import { render } from "./QuickAddProductComponent.vue?vue&type=template&id=094b4b86"
import script from "./QuickAddProductComponent.vue?vue&type=script&lang=js"
export * from "./QuickAddProductComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"platform/themes/iteam/assets/js/components/quick-add-product/QuickAddProductComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "094b4b86"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('094b4b86', __exports__)) {
    api.reload('094b4b86', __exports__)
  }
  
  module.hot.accept("./QuickAddProductComponent.vue?vue&type=template&id=094b4b86", () => {
    api.rerender('094b4b86', render)
  })

}


export default __exports__